var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"400px","line-height":"400px","font-size":"60px"}},[_c('strong',[_vm._v("welcome to wms")])])
}]

export { render, staticRenderFns }